import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" })
  ])
], -1)
const _hoisted_3 = { class: "card-body py-3" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_6 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-125px rounded-start" }, "#"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Product"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-225px" }, "Points"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Member Price"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Level"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Branch"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Action")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("option", { value: "1" }, "Single", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("option", { value: "2" }, "Double", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("option", { value: "3" }, "Triple", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("option", { value: "XXX" }, "Select Branch", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "material-icons" }, "search", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "material-icons" }, "save", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "material-icons" }, "cancel", -1)
const _hoisted_14 = {
  key: 4,
  href: "javascript:void(0);",
  class: "btn btn-success btn-sm dashboardFontStyle"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "row mb-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1" }),
  /*#__PURE__*/_createVNode("div", { class: "col-md-6 fv-row py-1" }),
  /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1" })
], -1)
const _hoisted_16 = {
  id: "divAmount",
  class: "row"
}
const _hoisted_17 = { class: "dashboardFontStyle" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("*** An amount of ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" (+ withholding tax and processing fee) will automatically be deducted from your account every month for your chosen auto PMA products.")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_font = _resolveComponent("font")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card"]
      }, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("table", _hoisted_5, [
              _hoisted_6,
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: index,
                    class: "auto-pma-prod-row",
                    style: _ctx.selected_prodcode.trim() == item.prodcode.trim() ? 'background-color: #D6EEEE;' : ''
                  }, [
                    _createVNode("td", null, "  " + _toDisplayString(item.recid), 1),
                    _createVNode("td", null, _toDisplayString(item.prodname), 1),
                    _createVNode("td", {
                      id: 'tdPoints_' + item.prodcode.trim()
                    }, _toDisplayString(parseFloat(_ctx.pospv_arr[index] * _ctx.autopma_level_selected[index]).toFixed(4)), 9, ["id"]),
                    _createVNode("td", {
                      id: 'tdPrice_' + item.prodcode.trim()
                    }, _toDisplayString(_ctx.numberWithCommas(parseFloat(_ctx.distPrice_arr[index]).toFixed(2) * parseFloat(_ctx.autopma_level_selected[index]))), 9, ["id"]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("select", {
                        class: "form-control dashboardFontStyle drp-level",
                        "onUpdate:modelValue": ($event: any) => (_ctx.autopma_level_selected[index] = $event),
                        onChange: ($event: any) => {_ctx.computePointsAndPrice(index);},
                        style: {"width":"100px !important"},
                        id: 'autopma_level_'+item.prodcode.trim(),
                        disabled: _ctx.autopma_level_dropdown_disabled_arr[index] == '1'
                      }, [
                        _hoisted_7,
                        _hoisted_8,
                        _hoisted_9
                      ], 40, ["onUpdate:modelValue", "onChange", "id", "disabled"]), [
                        [_vModelSelect, _ctx.autopma_level_selected[index]]
                      ])
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("select", {
                        class: "form-select form-select-solid",
                        "onUpdate:modelValue": ($event: any) => (_ctx.prodreleasebranchcode_selected[index] = $event),
                        disabled: _ctx.autopma_prodreleasebranchcode_dropdown_disabled_arr[index] == '1'
                      }, [
                        _hoisted_10,
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.branch_arr[index], (item2, index2) => {
                          return (_openBlock(), _createBlock("option", {
                            key: index2,
                            value: item2.branch_code
                          }, _toDisplayString(item2.description), 9, ["value"]))
                        }), 128))
                      ], 8, ["onUpdate:modelValue", "disabled"]), [
                        [_vModelSelect, _ctx.prodreleasebranchcode_selected[index]]
                      ])
                    ]),
                    _createVNode("td", null, [
                      (_ctx.selectBtn_arr[index] == '1')
                        ? (_openBlock(), _createBlock("button", {
                            key: 0,
                            type: "button",
                            disabled: _ctx.selectBtn_disabled_arr[index] == '1',
                            class: "btn btn-info dashboardFontStyle btnsearch me-2",
                            style: {"padding":"6px!important"},
                            id: 'selectBtn_'+item.prodcode.trim(),
                            onClick: ($event: any) => {_ctx.selectProduct(item.prodcode.trim(),index);},
                            title: "Select"
                          }, [
                            _hoisted_11
                          ], 8, ["disabled", "id", "onClick"]))
                        : _createCommentVNode("", true),
                      ((_ctx.btnsave_show || _ctx.saveBtn_arr[index] == '1') && _ctx.isprocessing[index] === '0')
                        ? (_openBlock(), _createBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-success dashboardFontStyle btnsave me-2",
                            style: {"padding":"6px!important"},
                            id: 'saveBtn_'+item.prodcode.trim(),
                            onClick: ($event: any) => {_ctx.saveAutoPMANow(item.prodcode.trim(),index);},
                            title: "Save"
                          }, [
                            _hoisted_12
                          ], 8, ["id", "onClick"]))
                        : _createCommentVNode("", true),
                      ((_ctx.btncancel_show || _ctx.cancelBtn_arr[index] == '1') && _ctx.isprocessing[index] === '0')
                        ? (_openBlock(), _createBlock("button", {
                            key: 2,
                            type: "button",
                            class: "btn btn-danger dashboardFontStyle btncancel me-2",
                            style: {"padding":"6px!important"},
                            id: 'cancelBtn_'+item.prodcode.trim(),
                            onClick: ($event: any) => {_ctx.resetTablePoints(index);},
                            title: "Cancel"
                          }, [
                            _hoisted_13
                          ], 8, ["id", "onClick"]))
                        : _createCommentVNode("", true),
                      ((_ctx.selected_prodcode.trim() == item.prodcode.trim() && _ctx.isprocessing[index] === '0') || _ctx.stopBtn_arr[index] == '1')
                        ? (_openBlock(), _createBlock("button", {
                            key: 3,
                            type: "button",
                            class: "btn btn-warning dashboardFontStyle me-2",
                            style: {"padding":"6px!important"},
                            id: 'stopBtn_'+item.prodcode.trim(),
                            onClick: ($event: any) => {_ctx.stopAutoPMANow(index);}
                          }, "Stop Auto PMA", 8, ["id", "onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.isprocessing[index] === '1')
                        ? (_openBlock(), _createBlock("a", _hoisted_14, "Processing..."))
                        : _createCommentVNode("", true)
                    ])
                  ], 4))
                }), 128))
              ])
            ])
          ]),
          _hoisted_15,
          _withDirectives(_createVNode("div", _hoisted_16, [
            _createVNode("p", _hoisted_17, [
              _hoisted_18,
              _createVNode("b", null, [
                _createVNode(_component_font, { color: "green" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.numberWithCommas(_ctx.warningAmount.toFixed(2))), 1)
                  ]),
                  _: 1
                })
              ]),
              _hoisted_19
            ])
          ], 512), [
            [_vShow, _ctx.divAmount_show == true]
          ])
        ])
      ], 2)
    ], 512), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}